import React from 'react';
import Blog from '../Components/blog-page/blo2/blog2';

function BlogPage() {
  return (
    <div>
      <Blog />
    </div>
  );
}

export default BlogPage;
